import api from './BaseApi';

export const createAirline = async (data) => {
    try {
        const response = await api.post('/admin/airlines', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response; 
    } catch (error) {
        console.error('Create Airline error:', error);
        return error;
    }
};

export const getAirlines = async (params) => {
    try {
        const response = await api.get('/admin/airlines', { params });
        return response.data;
    } catch (error) {
        console.error('Get airlines error:', error);
    }
};

export const getAirlineDetails = async (iata) => {
    try {
        const response = await api.get(`/admin/airlines/${iata}`);
        return response.data;
    } catch (error) {
        console.error('Get airline details error:', error);
        return error;
    }
};

export const updateAirline = async (iata, payload) => {
    try {
        const response = await api.put(`/admin/airlines/${iata}`, payload, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response;
    } catch (error) {
        console.error('Update Airline error:', error);
        return error;
    }
};

export const deleteAirline = async (iata) => {
    try {
        const response = await api.delete(`/admin/airlines/${iata}`);
        return response.data;
    } catch (error) {
        console.error('Delete Airline error:', error);
        return error;
    }
};

export const updateAirlineStatus = async (iata, payload) => {
    try {
        const response = await api.patch(`/admin/airlines/${iata}/status`, payload);
        return response; 
    } catch (error) {
        console.error('Update airline status error:', error);
        throw error;
    }
};